import $ from 'jquery';
import loadGoogleMapsApi from 'load-google-maps-api';

if($('#event-content-venue-map').length > 0) {
  loadGoogleMapsApi({
    key: 'AIzaSyA0o5HRDh7sq5RLkHEgzvY4XJGAfztKQX0',
  }).then(initMap);
}

var mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];

var map;
var geocoder;

function initMap() {
  var latlng = new google.maps.LatLng(-34.397, 150.644);
  map = new google.maps.Map(document.getElementById('event-content-venue-map'), {
    zoom: 12,
    center: latlng,
    styles: mapStyles,
    disableDefaultUI: true,
    scrollwheel: false
  });
  codeAddress();
}

function codeAddress() {
  geocoder= new google.maps.Geocoder();
  var address = $('#event-content-venue-map').attr('data-location');
  if(address != "" ) {
    geocoder.geocode({'address': address}, function (results, status) {
      if (status == 'OK') {
        map.setCenter(results[0].geometry.location);
        var marker = new google.maps.Marker({
          map: map,
          position: results[0].geometry.location
        });
      } else {
        console.log('Geocode was not successful for the following reason: ' + status);
      }
    });
  }
}

// TODO: Do we need this old conference code here?
if ((new RegExp('summer-conference-2017', 'g')).test(window.location)) {
  // hook up slider
  import('./vendor/jquery.bxslider.min.js').then(function() {
    $('.event-content-image-list').bxSlider({
      minSlides: 1,
      maxSlides: 4,
      slideWidth: 200,
      slideMargin: 5,
      hideControlOnEnd: true,
      pager: false,
      nextText: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
      prevText: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
      infiniteLoop: false,
      useCSS: false
    });
    $sliderImageViewport = $('.event-content-image-viewport img');

    $('.event-content-image-item').on('click', function(e) {
      e.preventDefault();
      var $item = $(this);

      if ($item.hasClass('current')) {
        return;
      }

      var imgSrc = $item.attr('data-image');

      $('.event-content-image-item.current').removeClass('current');

      $item.addClass('current');

      $sliderImageViewport.attr('src', imgSrc);
    });
  });

}
